import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#262633",
      "stroke-width": "2",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 1.6.376 3.112 1.043 4.453.178.356.237.763.134 1.148l-.595 2.226a1.3 1.3 0 0 0 1.591 1.591l2.226-.595a1.634 1.634 0 0 1 1.149.133A9.958 9.958 0 0 0 12 22Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#262633",
      d: "m13.58 13.132-.202.213s-.481.507-1.794-.876c-1.314-1.382-.833-1.889-.833-1.889l.128-.134c.314-.33.344-.862.07-1.25l-.56-.792c-.34-.48-.995-.543-1.384-.133l-.698.734c-.192.203-.321.466-.306.758.04.746.36 2.352 2.14 4.226 1.887 1.987 3.658 2.066 4.382 1.995.229-.023.428-.146.589-.316l.631-.664c.426-.449.306-1.218-.24-1.532l-.848-.489a.869.869 0 0 0-1.074.15Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "WhatsApp"}) } }